import React from "react";
import { withAuth } from "../shared/containers/containerAuth";
import NavigationItem from "./navigationItem";
import styles from "./navigation.module.scss";

const menu = [
  {
    title: "CMS",
    link: "/cms",
    permission: 10001,
  },
  {
    title: "Мониторинг",
    link: "/cars",
  },
  {
    title: "Зимнее содержание",
    link: "/winter/maintenance",
    permission: 36001,
  },
  {
    title: "Логистика",
    link: "/logistic/controlPoints",
    permission: [
      26001, 26002, 26003, 26004, 26005, 27001, 27002, 27003, 27004, 27005, 27006, 28001, 28002, 28003, 29001, 29002, 29003, 29004, 29005,
      29006, 29007, 29008, 31001, 32001, 32002, 46001, 46002, 46003, 47001, 47002, 49001, 49002, 49003, 52003, 52004, 53001, 53002, 53003,
      54001, 54002, 54003, 54004, 54005,
    ],
  },
  {
    title: "Отчёты",
    link: "/reports",
  },
  {
    title: "Управление",
    link: "/controls",
  },
  {
    title: "Заявки",
    link: "/jobRequests",
    permission: 65001,
  },
];

const Navigation = (props) => {
  return (
    <div className={styles.navbarWrapper}>
      {menu.map((item, key) => {
        if (item.permission === undefined) {
          return <NavigationItem content={item} key={key} />;
        } else {
          if (Array.isArray(item.permission)) {
            const some = item.permission.some((x) => {
              return props.data.permissions.includes(x);
            });

            if (some) {
              return <NavigationItem content={item} key={key} />;
            }
          }

          if (props.data.permissions.includes(item.permission)) {
            return <NavigationItem content={item} key={key} />;
          }
        }

        return null;
      })}
    </div>
  );
};

export default withAuth(React.memo(Navigation));
